export default function MidSection() {
  return (
    <section className="bg-gradient-to-br from-[#2b9cf0] via-[#3d6ee8] to-[#8a3cfb] text-white text-center py-28 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-5xl md:text-6xl font-extrabold mb-6 transition-transform transform hover:scale-105">
          Empieza a reservar con <span className="text-white">IA</span> hoy
        </h2>

        {/* Subtítulo */}
        <p className="text-lg md:text-xl text-white/90 mb-10 transition-transform transform hover:scale-102">
          Únete a miles de usuarios que ya disfrutan de una forma más inteligente de reservar
        </p>

        {/* Botones */}
        <div className="flex flex-wrap justify-center gap-5 mb-8">
          <a
            href="https://form.typeform.com/to/CHIQK53p"
            className="bg-white text-gray-900 px-8 py-3 md:py-4 rounded-full font-semibold text-lg shadow-md hover:scale-105 hover:shadow-lg transition-transform transform flex items-center gap-2"
          >
            Comenzar gratis →
          </a>
          <a
            href="#demo"
            className="border-2 border-white text-white px-8 py-3 md:py-4 rounded-full font-semibold text-lg hover:bg-white/10 hover:scale-105 transition-transform transform"
          >
            Agendar demo
          </a>
        </div>

      </div>

      {/* Fondo degradado suave */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1b1d3a]/40 pointer-events-none"></div>
    </section>
  );
}
